import { Outlet } from "react-router";
import Dashboard from "legacy/containers/Dashboard";

export const GlobalLegacyLayout = () => (
  <Dashboard withShopOnboarding={false}>
    <Outlet />
  </Dashboard>
);
